import React from 'react';
import './SystemAccessSection.css';
import urls from '../config/urls';

const SystemAccessSection = () => {
  const systemLink = urls.systemAccess;

  return (
    <section id="acceso-sistema" className="system-access-section">
      <div className="container">
        <div className="access-content">
          <div className="access-header">
            <div className="section-badge">
              <span className="badge-icon">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M12 1a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3h8zM4 6v2h8V6H4zm0 4v2h5v-2H4z" fill="currentColor"/>
                </svg>
              </span>
              Acceso a Plataforma
            </div>
            <h2 className="section-title">
              Tu <span className="gradient-text">Historial Médico</span> Inteligente te Espera
            </h2>
            <p className="section-subtitle">
              Pacientes y médicos, ingresen a la plataforma ThinkHealth para gestionar su salud
              y consultas con la potencia de la Inteligencia Artificial.
            </p>
          </div>

          <div className="access-features">
            <div className="feature-item">
              <div className="feature-icon">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <path d="M16 6a10 10 0 1 0 0 20 10 10 0 0 0 0-20z" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <path d="M12 16l3 3 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3>Para Pacientes</h3>
              <p>Accede a tu historial completo, programa citas y recibe atención personalizada con IA</p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <path d="M26 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <path d="M10 12h12M10 16h12M10 20h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              <h3>Para Médicos</h3>
              <p>Gestiona consultas, accede a diagnósticos asistidos por IA y optimiza tu práctica médica</p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <path d="M16 2L4 8v10c0 7.5 5.2 14.3 12 16 6.8-1.7 12-8.5 12-16V8L16 2z" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <path d="M12 16l3 3 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3>Seguro y Confiable</h3>
              <p>Datos protegidos con los más altos estándares de seguridad y privacidad médica</p>
            </div>
          </div>

          <div className="access-cta">
            <a href={systemLink} target="_blank" rel="noopener noreferrer" className="glass-button primary">
              <span className="btn-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M10 2v20l12-10L10 2z" fill="currentColor"/>
                </svg>
              </span>
              Ingresar al Sistema ThinkHealth
              <span className="btn-arrow">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M7 14l3-3-3-3M13 8v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
            </a>
            <p className="access-note">
              Acceso disponible 24/7. Si necesitas ayuda, contáctanos en 
              <a href={`mailto:${urls.supportEmail}`}> {urls.supportEmail}</a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SystemAccessSection;
